import Image from "next/image";
import photoAboutHistory from "/public/photo-aboutHistory.webp";

const histories = [
  {
    title: "2008年2月",
    body: "設立",
  },
  {
    title: "2010年10月",
    body: "日本初のトイレの検索サイト REST.jp オープン",
  },
  {
    title: "2011年12月",
    body: "水道橋オフィス（神田中央ビル）に移転",
  },
  {
    title: "2013年8月",
    body: "水道橋オフィス（佐藤ビル）に移転",
  },
  {
    title: "2014年1月",
    body: "iPhoneクイズアプリ「鉄道クイズ～出発進行～」リリース",
  },
  {
    title: "2015年4月",
    body: "水道橋オフィス（第2ハンタービル）に移転",
  },
  {
    photo: true,
  },
  {
    title: "2016年4月",
    body: "商店街のためのホームページ管理サービス「商店街CMS」リリース",
  },
  {
    title: "2017年1月",
    body: "保育園のためのホームページ運用サービス「保育園CMS」リリース",
  },
  {
    title: "2018年4月",
    body: "歯科医院のためのホームページ運用サービス「TOCCA DENALWEB BASIC」リリース",
  },
  {
    title: "2020年4月",
    body: "神保町オフィス（ワカヤギビル）に移転",
  },
];

export const AboutHistory = (props) => {
  return (
    <div id="history" className="--offset">
      <div className="relative mx-auto box-border grid max-w-7xl grid-cols-1 gap-2 px-6 sm:px-8 md:grid-cols-4 md:gap-0 md:px-12 xl:px-0">
        <div className="relative z-10 col-span-1">
          <h3 className="font-bold text-ter fluid-text-[16px,18px]">History</h3>
        </div>
        <div className="col-span-3 flex flex-col divide-y divide-solid divide-bdc-light border-x-0 border-y border-solid border-bdc-light">
          {histories.map((history) => (
            <dl
              className="grid grid-cols-1  border-x-0 py-2 md:grid-cols-4 md:py-4"
              key={history.index}
            >
              {history.title && (
                <dt className="col-span-1 text-ter fluid-text-[12px,16px]">
                  {history.title}
                </dt>
              )}
              {history.body && (
                <dd className="col-span-3 text-txt-base fluid-text-[12px,16px]">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: `${history.body}`,
                    }}
                  />
                </dd>
              )}
              {history.photo && (
                <div className="relative col-span-4 aspect-2/1 w-full">
                  <Image
                    src={photoAboutHistory}
                    alt="history of ToccaSystems"
                    quality={80}
                    layout="fill"
                    objectFit="cover"
                  />
                </div>
              )}
            </dl>
          ))}
        </div>
      </div>
    </div>
  );
};
